import { gql, graphql } from "react-apollo"

const MUTATE_INVITE_KIOSK = gql`
  mutation InviteKiosk($id: ID!) {
    inviteKiosk(id: $id) {
      sentAt
      email
    }
  }
`

const mutateInviteKiosk = graphql(MUTATE_INVITE_KIOSK, {
  name: "mutateInviteKiosk",
  props: ({ mutateInviteKiosk }) => ({
    inviteKiosk: (id: string) =>
      mutateInviteKiosk({
        variables: { id: id }
      })
  })
})

export default mutateInviteKiosk



// WEBPACK FOOTER //
// ./src/Kiosks/queries/mutateInviteKiosk.js